import type { ReplyDraft, Ticket, TicketDraft } from "@omnabase/shared";
import { mentionIds } from "../../lib/mentions";

/** The reply bar's Send for a saved reply (the queue-and-chat-column round, 2026-11-03, part five; the red team's finding 28, question 5).
 *  Pure. The send is built from the stored row alone, as the person left it: its text, its status choice (else the person's default), its
 *  signature switch, the AI draft it started from while that is still the open draft; the To line is the page's (restored from the row).
 *  What the row can never hold sends nothing: files, or a forum reply's private fields; then the box opens with the saved words instead. */
export const savedReplyNeedsBox = (saved: ReplyDraft, ticket: Pick<Ticket, "replyVia" | "replyFields">): boolean =>
  saved.hadFiles || ((saved.to?.via ?? ticket.replyVia) === "site" && (ticket.replyFields ?? []).length > 0);

export function savedReplyBody(saved: ReplyDraft, o: { draft: TicketDraft | null; sendAs: string }): Record<string, unknown> {
  return {
    kind: "reply", body: saved.text || "(files)", html: saved.html, mentions: mentionIds(saved.html), attachmentIds: [],
    status: saved.sendAs ?? o.sendAs,
    ...(o.draft && saved.aiDraftId === o.draft.id ? { draftId: o.draft.id } : {}),
    ...(saved.signature === false ? { signature: false } : {}),
  };
}
